import { GridColDef } from '@mui/x-data-grid'
import CellStatus, { Color } from '@/components/GokuDataGrid/CellStatus'
import CellDate from '@/components/GokuDataGrid/CellDate'
import { ResellerService } from '@/modules/Reseller/types'
import { TFunction } from 'i18next'
import { Typogaphy } from 'vnetwork-ui'
import { Link } from 'react-router-dom'
import { generatePathDatacentral, paths } from '@/utils/path'

const SERVICE_STATUS_OPTIONS = (t: TFunction) => [
    {
        label: t('active'),
        value: 'active',
        color: 'success' as Color,
    },
    {
        label: t('pending'),
        value: 'pending',
        color: 'warning' as Color,
    },
    {
        label: t('suspended'),
        value: 'suspended',
        color: 'error' as Color,
    },
    {
        label: t('cancelled'),
        value: 'cancelled',
        color: 'default' as Color,
    },
]

const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 0,
    }).format(value)
}

export const columns = (t: TFunction): GridColDef<ResellerService>[] => [
    {
        field: 'service_id',
        headerName: t('service_id'),
        width: 100,
        sortable: false,
        renderCell: ({ row }) => (
            <Link
                to={generatePathDatacentral(paths.serviceDetail, {
                    id: row.service_id.toString(),
                })}
                className="text-primary hover:underline font-medium"
            >
                #{row.service_id}
            </Link>
        ),
    },
    {
        field: 'service_name',
        headerName: t('service_name'),
        flex: 1,
        minWidth: 200,
        sortable: false,
        renderCell: ({ row }) => (
            <Link
                to={generatePathDatacentral(paths.serviceDetail, {
                    id: row.service_id.toString(),
                })}
                className="text-primary hover:underline"
            >
                {row.service_name}
            </Link>
        ),
    },
    {
        field: 'customer_name',
        headerName: t('customer'),
        flex: 1,
        minWidth: 150,
        sortable: false,
        renderCell: ({ row }) => (
            <Link
                to={generatePathDatacentral(paths.customerDetail, {
                    id: row.customer_id.toString(),
                })}
                className="text-primary hover:underline"
            >
                {row.customer_name}
            </Link>
        ),
    },
    {
        field: 'service_status',
        headerName: t('status'),
        width: 120,
        sortable: false,
        renderCell: ({ row }) => {
            const status = SERVICE_STATUS_OPTIONS(t)?.find(
                (item) => item?.value === row.service_status
            )

            return (
                <CellStatus
                    label={status?.label || row.service_status || t('active')}
                    color={status?.color as Color}
                    className="capitalize min-w-[80px]"
                />
            )
        },
    },
    {
        field: 'price_recurring',
        headerName: t('monthly_price'),
        width: 150,
        sortable: false,
        renderCell: ({ row }) => (
            <Typogaphy className="font-medium">
                {formatCurrency(row.price_recurring || 0)}
            </Typogaphy>
        ),
    },
    {
        field: 'created_at',
        headerName: t('created_at'),
        width: 140,
        sortable: false,
        renderCell: ({ row }) =>
            row.created_at ? (
                <CellDate date={row.created_at} />
            ) : (
                <Typogaphy>-</Typogaphy>
            ),
    },
]
